const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Refund Policy</h1>
          <p className="legal-effective">Effective Date: November 30, 2024</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <p>At Giant-Tree Foundation (operating as Elderra), we are committed to providing high-quality services and ensuring customer satisfaction. However, we understand that there may be instances where you may need to request a refund. Please read our refund policy carefully to understand the conditions and process.</p>

            <h2>1. General Refund Policy</h2>
            <h3>1.1 Eligibility for Refunds</h3>
            <p>Refunds are only applicable under the following conditions:</p>
            <ul>
              <li>The service you booked or subscribed to was not delivered as promised due to a fault on our end.</li>
              <li>A DigiCoach failed to show up for a scheduled session, and no rescheduling was possible.</li>
              <li>Technical issues on our platform prevented you from using the service, and these issues were not resolved within a reasonable time.</li>
            </ul>

            <h3>1.2 Non-Refundable Cases</h3>
            <p>Refunds will not be issued for:</p>
            <ul>
              <li>User dissatisfaction arising from a lack of effort or engagement during training sessions.</li>
              <li>Situations where the user failed to attend scheduled sessions without prior cancellation or rescheduling.</li>
              <li>Services that have already been rendered or partially completed.</li>
            </ul>

            <h3>1.3 Subscription Refunds</h3>
            <p>For users on subscription plans (monthly or annual):</p>
            <ul>
              <li>Refunds for unused months will be processed only if the subscription is canceled within the first 7 days of the billing period.</li>
              <li>No refunds will be issued for partial months.</li>
            </ul>

            <h2>2. Requesting a Refund</h2>
            <h3>2.1 How to Submit a Refund Request</h3>
            <p>Email your refund request to support@elderra.io with the following details:</p>
            <ul>
              <li>Full Name</li>
              <li>Contact Information</li>
              <li>Booking or Subscription ID</li>
              <li>Reason for Refund Request</li>
            </ul>

            <h3>2.2 Timeframe for Requests</h3>
            <p>Refund requests must be submitted within 7 days of the scheduled service date or the start of the subscription period.</p>

            <h3>2.3 Processing Time</h3>
            <p>All refund requests will be reviewed within 7 business days. Once approved, the refund will be processed within 10 business days to the original payment method.</p>

            <h2>3. Special Cases</h2>
            <h3>3.1 Group Classes</h3>
            <p>Refunds for group classes will only be issued if the class is canceled or rescheduled by Giant-Tree Foundation. No refunds will be provided for missed sessions.</p>

            <h3>3.2 DigiCoach Services</h3>
            <p>If a DigiCoach session does not meet expectations due to non-performance or other legitimate issues, we may offer a free replacement session instead of a refund.</p>

            <h2>4. Exceptions</h2>
            <h3>4.1 Force Majeure</h3>
            <p>Giant-Tree Foundation is not liable for disruptions caused by events beyond our control (e.g., natural disasters, government actions). Refunds in such cases will be evaluated on a case-by-case basis.</p>

            <h3>4.2 Promotional Offers</h3>
            <p>Refunds are not applicable to services or subscriptions purchased at discounted rates as part of promotions or special offers.</p>

            <h2>5. Contact Information</h2>
            <p>For any questions or concerns about our refund policy, please contact us at:</p>
            <p><strong>Email:</strong> hello@elderra.io</p>
            <p><strong>Address:</strong> H-294, PLOT 2, LANE 2, FIRST FLOOR, WESTEND MARG, NEAR SAKET, SAIDULAJAB, NEW DELHI 110030</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;